enum DocumentImportFormFieldNames {
  // Step 1 — source selection
  SourceKind = 'sourceKind',
  Files = 'files',
  Archive = 'archive',
  FtpUrl = 'ftpUrl',
  FtpUsername = 'ftpUsername',
  FtpPassword = 'ftpPassword',
  // Persisted from the FTP preview so the step-2 "Total documents" footer
  // can read the supported-files count (the preview result is otherwise
  // only held in FtpPreviewBlock's local state on step 1).
  FtpSupportedFilesCount = 'ftpSupportedFilesCount',
  // Step 2 — shared metadata is reused from DocumentFormFieldNames
}

export default DocumentImportFormFieldNames;
